import React, { useEffect } from "react";
import {
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import {
  authSelector,
  setUserBusinessType,
  userLoanCatSelector,
} from "../../services/redux/slices/authSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";
import { useDispatch } from "react-redux";
import { setDocumentDiscardModal } from "../../services/redux/slices/documentFormSlice";
import { setNotificationtype } from "../../services/redux/slices/notificationSlice";
interface MainHeadingProps {
  title: string;
  backButtonVisible: boolean;
  setToggle?: (value: string) => void; // Pass string directly
}
interface CustomToggleButtonProps {
  ownerState?: {
    selected: boolean;
  };
}

const CustomToggleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "ownerState",
})<CustomToggleButtonProps>(({ theme, ownerState }) => ({
  ...(ownerState?.selected && {
    backgroundColor: theme.palette.primary.main,
    color: "#072c2c",
    boxShadow: `0px 4px 12px 0px #5A5A5A2B`,
    background: `#fff`,
    borderRadius: `5px`,
    fontWeight: 600,
  }),
}));

const MainHeading: React.FC<MainHeadingProps> = ({
  title,
  backButtonVisible,
  setToggle,
}) => {
  const { loanCategory } = useSelector(authSelector);
  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState<string>("Term Loan");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNotificationtype("Term Loan"));
  }, []);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment == "Term Loan") {
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.TermLoan[0]?.businessId,
          name: "retail",
        })
      );
    } else {
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.Flexi[0]?.businessId,
          name: "flexi",
        })
      );
    }
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      if (setToggle) {
        setToggle(newAlignment); // This will update the alignment in MainDashboard
      }
    }
    dispatch(setNotificationtype(newAlignment));
  };

  const showButtons =
    loanCategory.Flexi.length > 0 && loanCategory.TermLoan.length > 0;

  const selectedFormType = useSelector(
    (state: RootState) => state?.documentFormSlice
  );
  const handleBackButton = () => {
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
    } else {
      navigate(-1);
    }
  };

  return (
    <Box>
      <Grid container mt={2} display="flex">
        <Grid item xs={6}>
          <Toolbar style={{ padding: "0px" }}>
            {backButtonVisible && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="back"
                onClick={() => handleBackButton()}
                sx={{ m: 0, pl: 0, p: 0.5, mr: 1, borderRadius: 0 }}
              >
                <ArrowBack />
              </IconButton>
            )}
            <Typography variant="h6" component="div" className="h1-text">
              {title}
            </Typography>
          </Toolbar>
        </Grid>
        <Grid item xs={6}>
          <Box display="flex" flexDirection="column" alignItems="flex-end">
            {!backButtonVisible && showButtons && (
              <ToggleButtonGroup
                color="primary"
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label="Loan Type"
                className="toggle-btn-group"
              >
                <CustomToggleButton
                  value="Term Loan"
                  ownerState={{ selected: alignment === "Term Loan" }}
                  className="toggle-btn"
                >
                  Term Loan
                </CustomToggleButton>
                <CustomToggleButton
                  value="Flexi Term Loan"
                  ownerState={{ selected: alignment === "Flexi Term Loan" }}
                  className="toggle-btn"
                >
                  Flexi Term Loan
                </CustomToggleButton>
              </ToggleButtonGroup>
            )}
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box mt={2}>{alignment === "Term Loan" && <Outlet />}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MainHeading;
